import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { GalleryGrid, GalleryImage } from '../components/GalleryGrid';
import { ImageModal } from '../components/ImageModal';
import { motion } from 'framer-motion';
// Mock Data
const allImages: GalleryImage[] = [
// Events
{
  id: 1,
  category: 'Events',
  title: 'Live DJ Set',
  src: 'https://images.unsplash.com/photo-1571266028243-371695039989?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 2,
  category: 'Events',
  title: 'Crowd Energy',
  src: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 3,
  category: 'Events',
  title: 'Stage Performance',
  src: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 4,
  category: 'Events',
  title: 'Nightlife Vibes',
  src: 'https://images.unsplash.com/photo-1533174072545-e8d4aa97edf9?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 5,
  category: 'Events',
  title: 'Special Guest',
  src: 'https://images.unsplash.com/photo-1501386761578-eac5c94b800a?q=80&w=1000&auto=format&fit=crop'
},
// Venue
{
  id: 6,
  category: 'Venue',
  title: 'Main Lounge',
  src: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 7,
  category: 'Venue',
  title: 'VIP Section',
  src: 'https://images.unsplash.com/photo-1578736641330-3155e606cd40?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 8,
  category: 'Venue',
  title: 'Rooftop View',
  src: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 9,
  category: 'Venue',
  title: 'Bar Area',
  src: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 10,
  category: 'Venue',
  title: 'Entrance Hall',
  src: 'https://images.unsplash.com/photo-1560624052-449f5ddf0c31?q=80&w=1000&auto=format&fit=crop'
},
// Food
{
  id: 11,
  category: 'Food',
  title: 'Signature Cocktails',
  src: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 12,
  category: 'Food',
  title: 'Gourmet Entrees',
  src: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 13,
  category: 'Food',
  title: 'Appetizer Platter',
  src: 'https://images.unsplash.com/photo-1541544744-5e3a01994119?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 14,
  category: 'Food',
  title: 'Dessert Selection',
  src: 'https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 15,
  category: 'Food',
  title: 'Premium Drinks',
  src: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?q=80&w=1000&auto=format&fit=crop'
},
// Nightlife
{
  id: 16,
  category: 'Nightlife',
  title: 'Dance Floor',
  src: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 17,
  category: 'Nightlife',
  title: 'Light Show',
  src: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 18,
  category: 'Nightlife',
  title: 'Party Atmosphere',
  src: 'https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 19,
  category: 'Nightlife',
  title: 'Celebration',
  src: 'https://images.unsplash.com/photo-1530103862676-de3c9da59af7?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 20,
  category: 'Nightlife',
  title: 'Late Night',
  src: 'https://images.unsplash.com/photo-1574391884720-2e4552002624?q=80&w=1000&auto=format&fit=crop'
}];
const categories = ['All', 'Events', 'Venue', 'Food', 'Nightlife'];
export function Gallery() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(null);
  const filteredImages = activeCategory === 'All' ? allImages : allImages.filter(img => img.category === activeCategory);
  const handleNext = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex(prev => prev === filteredImages.length - 1 ? 0 : (prev || 0) + 1);
  };
  const handlePrev = () => {
    if (selectedImageIndex === null) return;
    setSelectedImageIndex(prev => prev === 0 ? filteredImages.length - 1 : (prev || 0) - 1);
  };
  return <div className="min-h-screen bg-[#0B1014] text-white selection:bg-[#DDA247] selection:text-[#0B1014]" data-id="element-1028">
      <Header data-id="element-1029" />

      <main className="pt-32 pb-24 px-4 md:px-8 max-w-[1600px] mx-auto" data-id="element-1030">
        {/* Header Section */}
        <div className="text-center mb-16" data-id="element-1031">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-6xl font-bold mb-4 tracking-tight" data-id="element-1032">
            GALLERY
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-lg md:text-xl tracking-wide mb-12" data-id="element-1033">
            Moments from House of Flavors
          </motion.p>

          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-1034">
            {categories.map((category, index) => <motion.button key={category} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + index * 0.05
          }} onClick={() => setActiveCategory(category)} className={`px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wider transition-all duration-300 ${activeCategory === category ? 'bg-[#DDA247] text-[#0B1014]' : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'}`} data-id="element-1035">
                {category}
              </motion.button>)}
          </div>
        </div>

        {/* Gallery Grid */}
        <GalleryGrid images={filteredImages} onImageClick={setSelectedImageIndex} data-id="element-1036" />
      </main>

      <Footer data-id="element-1037" />

      {/* Lightbox Modal */}
      <ImageModal isOpen={selectedImageIndex !== null} image={selectedImageIndex !== null ? filteredImages[selectedImageIndex].src : ''} title={selectedImageIndex !== null ? filteredImages[selectedImageIndex].title : ''} category={selectedImageIndex !== null ? filteredImages[selectedImageIndex].category : ''} currentIndex={selectedImageIndex || 0} totalImages={filteredImages.length} onClose={() => setSelectedImageIndex(null)} onNext={handleNext} onPrev={handlePrev} data-id="element-1038" />
    </div>;
}